import { useEffect } from 'react';

import { useLogout } from './_hooks';
import { isDeadSessionError } from './_helpers';
import { useSelf } from '@/data/user';

import { PageLoading, PageError } from '@/app/ui/page';

const UserAuthentication = ({ children }) => {
  const self = useSelf();
  const logout = useLogout();
  const isDeadSession = isDeadSessionError(self.error);

  // Nothing under this component can render without a user, and the error page below has
  // no way back out of the app - the credential the API keeps rejecting stays in the
  // browser, so the only escape was clearing it by hand in DevTools. Drop it and go back
  // to login instead.
  useEffect(() => {
    if (isDeadSession) {
      logout();
    }
  }, [isDeadSession, logout]);

  // Keep the loading page up while the redirect logout above navigates away, so the error
  // page never flashes on a session that is simply over.
  if (isDeadSession || (self.isLoading && !self.data)) {
    return <PageLoading variant="app" />;
  }

  if (self.error) {
    return <PageError dataTestId="user-authentication-error" message="An error occurred loading user. Try logging out and logging back in." />;
  }

  return children;
};

export default UserAuthentication;
